import { render } from "./DeactivateCampaignAction.vue?vue&type=template&id=66416866"
import script from "./DeactivateCampaignAction.vue?vue&type=script&lang=ts"
export * from "./DeactivateCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script